module.exports = __webpack_public_path__ + "bradavice_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_4_after.jpg
// module id = 935
// module chunks = 0